import { useState } from "react";
import { FileText, AppWindow, Package, BookOpenCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { downloadPath, errMsg } from "@/lib/api";

const ITEMS = [
  ["complete", "Complete edition", FileText], ["vol1", "Volume I", FileText], ["vol2", "Volume II", FileText], ["vol3", "Volume III", FileText],
  ["sample", "Free sample", BookOpenCheck], ["toolkit", "Mobile relocation app", AppWindow],
  ["software_zip", "Software pack", Package], ["bundle", "Full bundle", Package], ["carousel_zip", "Instagram carousel", Package],
];
const mb = (b) => (b ? `${(b / 1048576).toFixed(1)} MB` : "");

export const RelocDownloads = ({ g }) => {
  const [busy, setBusy] = useState(null);
  const go = async (key) => {
    setBusy(key);
    try { await downloadPath(`/relocation/guides/${g.id}/files/${key}`, g.files[key].filename); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-px bg-[#E2D9CC] border border-[#E2D9CC]" data-testid="reloc-downloads">
      {ITEMS.filter(([k]) => g.files[k]).map(([key, title, Icon], i) => (
        <button key={key} data-testid={`reloc-download-${key}`} onClick={() => go(key)} disabled={!!busy}
          className={`text-left p-6 transition-colors group ${i === 0 ? "bg-[#3B1B48] text-[#FAF7F2] hover:bg-[#4A1E5C]" : "bg-[#FAF7F2] hover:bg-[#EFE6F3]"}`}>
          {busy === key ? <Loader2 className="w-5 h-5 animate-spin text-[#C59B27]" /> : <Icon className="w-5 h-5 text-[#C59B27]" strokeWidth={1.4} />}
          <p className="font-display text-lg mt-4">{title}</p>
          <p className={`text-xs mt-1 truncate ${i === 0 ? "text-[#EFE6F3]/70" : "text-[#8C827A]"}`}>{g.files[key].filename}</p>
          <p className={`text-xs ${i === 0 ? "text-[#C59B27]" : "text-[#3B1B48]"}`}>{mb(g.files[key].size)}</p>
        </button>
      ))}
    </div>
  );
};
